import { t } from "i18next";

export const QuestionType = Object.freeze({
  MCQ: "multiple_choice",
  CQ: "choice",
  ESSAY: "essay",
  YES_NO: "yes_no",
  CHECKBOX: "checkbox",
  SLIDER: "slider",
  SHORT_ANSWER: "short_answer",
  LONG_ANSWER: "long_answer",
});
export const QuestionTypeAIGen = Object.freeze({
  MCQ: "multiple-choice",
  CQ: "choice",
  ESSAY: "essay",
  YES_NO: "yes_no",
  CHECKBOX: "checkbox",
  SLIDER: "slider",
  SHORT_ANSWER: "short_answer",
  LONG_ANSWER: "long_answer",
});

export const QuestionTypeCustom = Object.freeze({
  MCQ: "mcq",
  CQ: "choice",
  ESSAY: "essay",
  YES_NO: "yes_no",
  CHECKBOX: "checkbox",
  SLIDER: "slider",
  SHORT_ANSWER: "short",
  LONG_ANSWER: "long",
});

export const STEP_ON_DEMAND_ENUM = Object.freeze({
  STEP_OBJECTIVE_ON_DEMAND: 1,
  STEP_WHAT_ASK: 2,
  STEP_WHO_ASK: 3,
  STEP_LOCATION_SETUP: 4,
  STEP_PREVIEW: 5,
});

const QuestionTypeMap = {
  multiple_choice: "mcq",
  choice: "choice",
  essay: "essay",
  yes_no: "yes_no",
  checkbox: "checkbox",
  slider: "slider",
  short_answer: "short",
  long_answer: "long",
};

export const getQuestionTypeValue = (type) => {
  return QuestionTypeMap[type] || type || "checkbox";
};

export const statusConfig = {
  DRAFT: {
    text: t("quest.status.draft"),
    color: "bg-gray-400",
  },
  PUBLISHED: {
    text: t("quest.status.onGoing"),
    color: "bg-amber-400",
  },
  IN_PROGRESS: {
    text: t("quest.status.onGoing"),
    color: "bg-amber-400",
  },
  COMPLETED: {
    text: t("quest.status.completed"),
    color: "bg-teal-500",
  },
  ARCHIVED: {
    text: t("quest.status.archived"),
    color: "bg-purple-500",
  },
};
